import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import { Table, TableModule } from 'primeng/table';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/SEC-Reports-columns.json';
import { CommonModule, NgClass, LowerCasePipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { OdrReportsService } from './odr-reports.service';
import { AddEditViewOdrReports } from './add-edit-view-odr-reports/add-edit-view-odr-reports';
import { ConfirmationService, MessageService } from 'primeng/api';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { map } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { asBlob, generateCsv } from 'export-to-csv';
import saveAs from 'file-saver';


@Component({
  selector: 'app-odr-reports',
  imports: [CommonModule, TableModule, ButtonModule, FormsModule,
        FilterPanelComponent, MatProgressSpinnerModule, NgClass, LowerCasePipe, DatePipe,
        MatTooltipModule, ConfirmDialogModule,ToastModule, QuickSearchComponent,AddEditViewOdrReports],
  templateUrl: './odr-reports.component.html',
  styleUrl: './odr-reports.component.scss'
})
export class OdrReportsComponent implements OnInit, OnDestroy {

  @ViewChild(('dt')) dt!: Table |any;
  quickFilterArray: any = GridColumnsJSON["SEC-Reports-Quick-Search-Fields"];
  gridColumns = GridColumnsJSON["SEC-Reports-Grid-Columns"];
  columns: any = [];
  public tbldatamsg = 'L o a d i n g . . . . .'; 
  emptytbldatamsg = "Data not found";
  subscription: any;
  selectedRow: any;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  isExportToCSV = false;
  rowData: any = [];
  showDialog = false;
  defaultFilterArray: any = [];
  isLoadingResults = false;
  rowcount!: number;
  totalRecords: any = 0;
  startLimit: number = 0;
  endLimit: number = 0;
  defaultData: any;
  dataset: any[] = [];
  isDisplayCommentViewer: boolean = false;
  isApprove:boolean =false;
  isDecline:boolean =false;
  commentStaticFilters!: any[];
  selectedRowIndex:any


  constructor(public userService: UserService,
          private readonly gridService: GridService,
          public constantService: ConstantService,
          private readonly sortPipe: SortPipe,
          private readonly emitterService: EmitterService,
          public odrReportsService:OdrReportsService,
          public confirmationService: ConfirmationService,
          private sharedHttpClientService: SharedHttpClientService,
          private urlsService: UrlsService,
          private messageService: MessageService,) {}

  
  ngOnInit(): void {
    this.odrReportsService.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.odrReportsService.endLimit = this.odrReportsService.rowcount
      this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
        if (value) {
          this.getData();
        }
      });
    this.getColumns();
    this.odrReportsService.defaultFilter();
    this.getData();
  }

  getColumns() {
    let column: any;
    column = this.gridColumns;
    this.columns = this.gridColumns.filter((col: any) => col.ui_columnname !== "Action");
    if (column !== null || column !== undefined) {
      this.gridColumns = this.gridService.getGridColumns(column);
    }
  }

  getData() {
    this.odrReportsService.reloadData();
  }

  sort(event:any) {
    if (event.multisortmeta[0].field != "") {
      if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
        this.sortClickCounter = this.sortClickCounter + 1;
      } else {
        this.sortClickCounter = 1;
      }
      if (this.sortClickCounter !== 3) {
        let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
        this.sortData.field = event.multisortmeta[0].field;
        this.sortData.order = sortOrder;
        this.dataset = this.sortPipe.transform(this.dataset, this.sortData.order, this.sortData.field);
      } else {
        this.resetSort();
      }
    }
  }

  resetSort() {
    this.dt.multiSortMeta[0].field = 'abc';
    this.dt.multiSortMeta[0].order = 0;
    this.dataset = this.defaultData;
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;
    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.getData();
  }

  FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.startLimit = 0;
    this.endLimit = this.rowcount
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.defaultFilterArray = $event;
    this.startLimit = 0;
    this.endLimit = this.rowcount;
    this.getData();
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.defaultFilterArray = $event;
    this.startLimit = 0;
    this.endLimit = this.rowcount;
    this.getData();
  }

  onApprove(ri:any, selectedRow:any) {
    this.isDisplayCommentViewer = true;
    this.isApprove = true;
    this.isDecline = false;
    this.selectedRowIndex = ri;
    this.selectedRow = selectedRow;
    /* Catch User Action Log */
      this.userService.logUserActivity("Approve ODR 606 Report", null, {
        'Text1': this.userService.userFirstName + ' Approved ODR 606 Report',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
      });
  }

  onDecline(ri:any, selectedRow:any) {
    this.isDisplayCommentViewer = true;
    this.isDecline = true;
    this.isApprove = false;
    this.selectedRowIndex = ri;
    this.selectedRow = selectedRow;
     /* Catch User Action Log */
      this.userService.logUserActivity("Decline ODR 606 Report", null, {
        'Text1': this.userService.userFirstName + ' Declined ODR 606 Report',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
      });
  }

  onDelete(ri:any, selectedRow:any) {
      this.confirmationService.confirm({
      message: 'Are you sure to delete?',
      key: 'informationDialoge',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button information-reject-button",

      accept: () => {
          let payload = {
            "mpid": this.userService.getActiveMPID(),
            "fileNames": selectedRow['fileNames'],
            "reportingStartDate": selectedRow['reportingStartDate'],
            "comments": selectedRow['comments'],
            "publishedBy": selectedRow['publishedBy'],
            "reportID": selectedRow['reportID'],
            "reportName": selectedRow['reportName'],
            "reportingYear": selectedRow['reportingYear'],
            "reportingEndDate": selectedRow['reportingEndDate'],
            "approvedBy": selectedRow['approvedBy'],
            "generationDate": selectedRow['generationDate'],
            "reportStatus": selectedRow['reportStatus'],
            "declinedBy": selectedRow['declinedBy'],
            "declinedDate": selectedRow['declinedDate'],
            "s3PathDraft":  selectedRow['s3PathDraft'],
            "reportType": selectedRow['reportType'],
            "approvedDate": selectedRow['approvedDate'],
            "reportingQuarter": selectedRow['reportingQuarter'],
            "s3PathPublished": selectedRow['s3PathPublished'],
            "publishedDate":selectedRow['publishedDate'],
            "generatedBy": selectedRow['generatedBy'],
          }

          /* Catch User Action Log */
          this.userService.logUserActivity("Delete ODR 606 Report", null, {
            'Text1': this.userService.userFirstName + ' Deleted ODR 606 Report',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
          });
          this.odrReportsService.isLoadingResults = true;

           return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Delete), payload)
          .pipe(map((response: Response) => {
              return response;
            })).subscribe({
              next: (data: any) => {
                this.odrReportsService.isLoadingResults = false;
                if(data.status) {
                  this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'Record deleted Successfully' });
                  this.getData();
                } else {
                   this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: data.Data
                  });
                }
              },        
              error: (err: HttpErrorResponse) => {
                this.odrReportsService.isLoadingResults = false;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: err.message
                });
              }
        });  

        },
        reject: () => {

        }
      });
  }

  downloadReport(ri:any, selectedRow:any) {
    /* Catch User Action Log */
    this.userService.logUserActivity("Download ODR 606 Report", null, {
      'Text1': this.userService.userFirstName + ' Download ODR 606 Report',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
    });

    const payload = {
      "reportID" : selectedRow.reportID
    }

    this.odrReportsService.isLoadingResults = true;


    this.odrReportsService.downloadReport(payload)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (data: any) => {
          this.odrReportsService.isLoadingResults = false;
          if (data.status) {
            const reportPresignedUrls: any[] = data.Data;

            this.downloadMultipleFiles(reportPresignedUrls)

            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Report download started'
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: data.Data
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.odrReportsService.isLoadingResults = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.message
          });
        }
      });

  }

async downloadMultipleFiles(urls: string[]): Promise<void> {
  for (const url of urls) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    link.remove();
    await new Promise(resolve => setTimeout(resolve, 2000));
  }
}

  genrateReport(){
    this.showDialog = true;
  }
  closeCommentDialogbox() {
    this.isDisplayCommentViewer = false;
  }

  exportToCSV() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });
    this.isExportToCSV = true;
    const filename = 'ODR_606_Reports_' + this.userService.getyyyyMMddDateFormate(new Date());
    let payload = {
      "mpid": this.userService.getActiveMPID(),
      "data": this.odrReportsService.defaultFilterArray,
      "startLimit": 0,
      "endLimit": this.odrReportsService.totalRecords
    }
    this.odrReportsService.getData(payload)
      .pipe(map((response: Response) => {
        return response;
      }))      
      .subscribe({
        next: (dataset: any) => {
          this.isExportToCSV = false;
            let data = dataset.Data;
            if (data.length > 0) {
              const options:any = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: filename,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: filename
              };
              const csv = generateCsv(options)(this.constantService.getExportData(data, GridColumnsJSON["SEC-Reports-Grid-Columns"]));
              const blob = asBlob(options)(csv);
              saveAs(blob, filename);
              this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.odrReportsService.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'No data found',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.odrReportsService.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            }
        },
        error: (err: HttpErrorResponse) => {
          this.isExportToCSV = false;
        }
      });  
    }
  }

  ngOnDestroy(): void {
      if (this.subscription)
        this.subscription.unsubscribe();
  }

}
